import React from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { MapPin, ArrowUp } from "lucide-react";
import { categories } from "../data/categories";
import { scroller } from "react-scroll";
import "./Footer.css";

const MAPS_URL = "https://maps.app.goo.gl/MjzuXp7gDD6bn5Pn6";
const WHATSAPP_URL = "https://wa.me/306949794405";

export default function Footer() {
  const navigate = useNavigate();

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const goToSection = (section) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scroller.scrollTo(section, { smooth: true, offset: -70, duration: 500 }), 120);
    } else {
      scroller.scrollTo(section, { smooth: true, offset: -70, duration: 500 });
    }
  };

  return (
    <footer className="footer-section">
      <div className="container footer-container">
        <div className="footer-column">
          <h3 className="footer-brand">Demollari E.E.E</h3>
          <ul className="footer-links">
            {["home", "about", "products", "contact"].map((section) => (
              <li key={section}>
                <button type="button" onClick={() => goToSection(section)}>
                  {section.charAt(0).toUpperCase() + section.slice(1)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column">
          <h4>Our Products</h4>
          <ul className="footer-direct">
            {categories.map((category) => (
              <li key={category.slug}>
                <button type="button" onClick={() => navigate(`/products/${category.slug}`)}>
                  {category.navTitle}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contact</h4>
          <div className="footer-contact">
            <button type="button" onClick={() => window.open(MAPS_URL, "_blank", "noopener,noreferrer")}>
              <MapPin size={16} /> Σιθωνίας 2ο χλμ, Nea Moudania 632 00, Greece
            </button>
            <button type="button" onClick={() => window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer")}>
              <FaWhatsapp size={16} /> +30 694 979 4405
            </button>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="copyright">
            © {new Date().getFullYear()} Demollari E.E.E. All rights reserved.
          </p>

          <button type="button" className="back-to-top" onClick={scrollToTop}>
            <ArrowUp size={16} /> <span>Back to Top</span>
          </button>
        </div>
      </div>
    </footer>
  );
}
